/* V13.1: phone and email are required for every website enquiry.
   Website-source labels, villa matcher, submit endpoint and successful-form detection are preserved.
   Format checks are browser validation, not verification that a number is reachable. */
(() => {
  'use strict';
  const source = 'Sivana Villas website enquiry';
  const pageURL = () => 'https://sivanavillas.com' + window.location.pathname;
  let config = {};
  try { config = JSON.parse(document.getElementById('SivanaSourceConfig')?.textContent || '{}'); } catch (_) {}
  const clientEmail = String(config.email || 'sivanavillas@gmail.com').toLowerCase();
  const message = () => source + '\nI am enquiring through sivanavillas.com.\nPage: ' + pageURL();
  const cleanCampaign = (value) => /^[\w .-]{1,80}$/.test(value || '') ? value : '';
  const params = new URLSearchParams(location.search);
  const campaign = ['utm_source', 'utm_medium', 'utm_campaign'].map(k => {
    const v = cleanCampaign(params.get(k)); return v ? k + ': ' + v : '';
  }).filter(Boolean).join(' | ');
  const form = document.getElementById('SivanaEnquiryForm');
  const phone = document.getElementById('SivanaPhone');
  const email = document.getElementById('SivanaEmail');
  const preferred = document.getElementById('SivanaPreferredContact');
  const syncContact = () => {
    if (!form) return;
    const page = form.querySelector('[data-sv-source-page]'); if (page) page.value = pageURL();
    const c = form.querySelector('[data-sv-campaign]'); if (c) c.value = campaign;
    // Reply preference must never make either contact field optional.
    if (phone) {
      phone.required = true;
      phone.setCustomValidity('');
      const label = document.querySelector('label[for="SivanaPhone"] span');
      if (label) label.textContent = '(required)';
    }
    if (email) email.required = true;
  };
  preferred?.addEventListener('change', syncContact);
  phone?.addEventListener('input', () => phone.setCustomValidity(''));
  form?.addEventListener('reset', () => { const progress = form.querySelector('[data-sv-funnel-progress]'); if (progress) progress.hidden = false; window.setTimeout(syncContact, 0); });
  form?.addEventListener('submit', event => {
    syncContact();
    const number = (phone?.value || '').trim();
    const digits = number.replace(/\D/g, '');
    const numberFormatOK = /^\+?[0-9\s().-]+$/.test(number);
    if (phone && (!numberFormatOK || digits.length < 7 || digits.length > 18 || /^0+$/.test(digits))) {
      const message = number
        ? 'Please enter a complete phone or WhatsApp number, including your country code.'
        : 'Please enter your phone or WhatsApp number. Phone and email are required for every enquiry.';
      phone.setCustomValidity(message);
      const validation = form.querySelector('[data-sv-funnel-validation]');
      if (validation) validation.textContent = message;
      event.preventDefault(); event.stopImmediatePropagation(); phone.focus(); phone.reportValidity();
    }
  }, true);
  syncContact();
  if (form?.querySelector('.sv-form-errors')) {
    const overlay = document.querySelector('[data-sv-funnel-overlay]');
    overlay?.classList.add('is-open'); overlay?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sv-lock');
  }
  // Only these customer-facing contact links receive a source label.
  const labelLink = (link) => {
    const raw = link.getAttribute('href') || '';
    if (/^mailto:/i.test(raw)) {
      const [recipient, query = ''] = raw.substring(7).split('?');
      if (decodeURIComponent(recipient).toLowerCase() !== clientEmail) return;
      const p = new URLSearchParams(query);
      p.set('subject', source);
      const oldBody = p.get('body') || '';
      if (!oldBody.includes(source)) p.set('body', message() + (oldBody ? '\n\n' + oldBody : ''));
      link.href = 'mailto:' + recipient + '?' + p.toString().replace(/\+/g, '%20');
      link.dataset.svContactChannel = 'email';
    } else {
      let url; try { url = new URL(raw, location.origin); } catch (_) { return; }
      if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') {
        const oldText = url.searchParams.get('text') || '';
        if (!oldText.includes(source)) url.searchParams.set('text', message() + (oldText ? '\n\n' + oldText : ''));
        link.href = url.toString(); link.dataset.svContactChannel = 'whatsapp';
      }
      if (url.hostname === 'lin.ee' || (url.hostname === 'line.me' && /\/R\/|\/ti\//.test(url.pathname))) {
        link.dataset.svContactChannel = 'line';
        if (/^@[A-Za-z0-9._-]+$/.test(config.line_id || '')) {
          link.href = 'https://line.me/R/oaMessage/' + encodeURIComponent(config.line_id) + '/?' + encodeURIComponent(message());
          link.dataset.svLinePrefilled = 'true';
        }
      }
    }
    if (/^tel:/i.test(raw)) link.dataset.svContactChannel = 'phone';
  };
  document.querySelectorAll('a[href]').forEach(labelLink);
  const dialog = document.getElementById('SivanaChannelDialog');
  let returnFocus = null;
  const close = () => { if (dialog?.open) dialog.close(); returnFocus?.focus(); };
  dialog?.querySelector('[data-sv-channel-close]')?.addEventListener('click', close);
  dialog?.addEventListener('close', () => returnFocus?.focus());
  dialog?.querySelector('[data-sv-copy-message]')?.addEventListener('click', async () => {
    const box = dialog.querySelector('[data-sv-channel-message]');
    const status = dialog.querySelector('[data-sv-channel-status]');
    try { await navigator.clipboard.writeText(box.value); status.textContent = 'Copied. Paste this into your message to Sivana.'; }
    catch (_) { box.focus(); box.select(); status.textContent = 'Select and copy this message, then paste it in LINE.'; }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-sv-channel-continue')) return;
    const channel = link.dataset.svContactChannel;
    if (!channel) return;
    // This is a local integration hook, not a claim that a call or message was delivered.
    document.dispatchEvent(new CustomEvent('sv:contact_click', {detail: {channel, path: location.pathname}}));
    const needsGuide = channel === 'phone' || (channel === 'line' && !link.dataset.svLinePrefilled);
    if (!needsGuide || !dialog || typeof dialog.showModal !== 'function') return;
    // Preserve new-tab/modifier-key browser behaviour; do not intercept it.
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault(); returnFocus = link;
    const box = dialog.querySelector('[data-sv-channel-message]');
    const copy = dialog.querySelector('[data-sv-copy-message]');
    const onward = dialog.querySelector('[data-sv-channel-continue]');
    const note = dialog.querySelector('[data-sv-channel-explanation]');
    box.value = message(); box.hidden = channel === 'phone'; copy.hidden = channel === 'phone';
    dialog.querySelector('[data-sv-channel-status]').textContent = '';
    document.getElementById('SivanaChannelTitle').textContent = channel === 'phone' ? 'Call Sivana Villas' : 'Message Sivana on LINE';
    note.textContent = channel === 'phone' ? 'Please mention that you found us on the Sivana Villas website. A normal phone call does not automatically show the webpage you came from.' : 'Copy the website enquiry message below, then open LINE and paste it into your chat with Sivana. This keeps the source of your enquiry clear to the sales team.';
    onward.href = link.href; onward.textContent = channel === 'phone' ? 'Call now' : 'Open Sivana on LINE';
    if (channel === 'phone') onward.removeAttribute('target'); else onward.target = '_blank';
    onward.rel = 'noopener'; dialog.showModal();
  });
})();
